<template>
  <stepper-layout
    :stepTitle="'Lease Info'"
    :stepIcon="'info_outline'"
  >
    <v-expansion-panels
      data-testid="lease-info-expansion-panel"
      class="lease-info-expansion-panel"
      v-model="panel"
      focusable
    >
      <v-expansion-panel
        data-testid="lease-info-emergency-expansion-content"
        class="lease-info-emergency-expansion-content"
        style="outline: grey 1px solid"
      >
      <v-expansion-panel-header>
        <v-layout
          text-h6
          justify-space-between
          align-center
        >
          Emergency Contact Information
        </v-layout>
      </v-expansion-panel-header>
        <v-expansion-panel-content>
        <v-layout column>
          <v-card min-width="100%">
            <v-layout class="pa-3 mt-2" column>
              <div class="subheading ml-1 mb-3">
                Enter the tenant's Emergency Contact information.
                <!-- <span class="font-weight-bold">Name and phone number required.</span> -->
              </div>
              <v-layout class="mb-1">
                <app-input
                  data-testid="rent-ec-name-input"
                  class="rent-ec-name-input mx-5"
                  v-model="ecName"
                  label="Emergency Contact Name"
                  :rules="{required: false}"
                  filled
                ></app-input>
                <app-input
                  data-testid="rent-ec-phone-input"
                  class="rent-ec-phone-input mx-5"
                  v-model="ecPhone"
                  label="Emergency Contact Phone #"
                  type="phone"
                  :rules="{required: false}"
                  filled
                ></app-input>
                <app-input
                  data-testid="rent-ec-email-input"
                  class="rent-ec-email-input mx-5"
                  v-model="ecEmail"
                  type="email"
                  :rules="{required: false}"
                  label="Emergency Contact Email Address"
                  filled
                ></app-input>
              </v-layout>
            </v-layout>
          </v-card>
        </v-layout>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel
        data-testid="lease-info-military-expansion-content"
        class="lease-info-military-expansion-content"
        style="outline: grey 1px solid"
      >
      <v-expansion-panel-header>
        <v-layout
            text-h6
            justify-space-between
            align-center
        >
            Military Status
        </v-layout>
      </v-expansion-panel-header>
        <v-expansion-panel-content>
        <v-layout column>
          <v-card min-width="100%">
            <v-layout class="pa-3 mt-2" column>
              <div class="subheading ml-1 mb-3">
                If the tenant or the tenant's spouse is an active member of the U.S. Armed Forces or other Uniformed
                Services, fill out <span class="font-weight-bold">both</span> fields below (leave blank if not).
              </div>
              <v-layout class="mb-1">
                <app-input
                  data-testid="rent-mc-name-input"
                  class="rent-mc-name-input mr-2"
                  v-model="mcName"
                  label="Military Contact Name"
                  :rules="{required: false}"
                  filled
                ></app-input>
                <app-input
                  id="rent-mc-phone-input"
                  class="rent-mc-phone-input ml-2"
                  v-model="mcPhone"
                  label="Military Contact Phone #"
                  type="phone"
                  :rules="{required: false, min: 10}"
                  filled
                ></app-input>
              </v-layout>
            </v-layout>
          </v-card>
        </v-layout>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel
        data-testid="lease-info-liens-expansion-content"
        class="lease-info-liens-expansion-content"
        style="outline: grey 1px solid"
      >
      <v-expansion-panel-header>
        <v-layout
          text-h6
          justify-space-between
          align-center
        >
          Liens Holders
        </v-layout>
      </v-expansion-panel-header>
        <v-expansion-panel-content>
        <v-layout column>
          <v-card min-width="100%">
            <v-layout class="pa-3 mt-2" column>
              <div class="subheading ml-1 mb-3">
                If there are any lien holders, parties that hold a security interest and/or third-party owners of any
                personal property the tenant intends to store, enter them below (leave blank if not).
                <span class="font-weight-bold">Include a name and address for each party.</span>
              </div>
              <v-layout class="mb-1">
                <v-textarea
                  data-testid="rent-liens-holders-textarea"
                  class="rent-liens-holders-textarea mr-2"
                  v-model="lienHolders"
                  label="Liens Holders"
                  filled
                />
              </v-layout>
            </v-layout>
          </v-card>
        </v-layout>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel
        data-testid="lease-info-property-expansion-content"
        class="lease-info-property-expansion-content"
        style="outline: grey 1px solid;"
      >
      <v-expansion-panel-header>
        <v-layout text-h6 justify-space-between align-center>
          Property To Be Stored
        </v-layout>
      </v-expansion-panel-header>
        <v-expansion-panel-content>
        <v-layout>
          <v-card min-width="100%">
            <v-layout class="pa-3 mt-2" column>
              <div class="subheading ml-1 mb-3">
                Select any types of property that the tenant intends to store.
              </div>
              <v-row>
                <v-col sm="2">
                <v-checkbox
                  data-testid="rent-property-household-checkbox"
                  class="rent-property-household-checkbox"
                  v-model="propertyTypes"
                  value="Household"
                >
                  <template v-slot:label>
                    <div class="subheading">Household</div>
                  </template>
                </v-checkbox>
                </v-col>
                <v-col sm="2">
                <v-checkbox
                  data-testid="rent-property-clothing-checkbox"
                  class="rent-property-clothing-checkbox"
                  v-model="propertyTypes"
                  value="Clothing"
                >
                  <template v-slot:label>
                    <div class="subheading">Clothing</div>
                  </template>
                </v-checkbox>
                </v-col>
                <v-col sm="2">
                <v-checkbox
                  data-testid="rent-property-furniture-checkbox"
                  class="rent-property-furniture-checkbox"
                  v-model="propertyTypes"
                  value="Furniture"
                >
                  <template v-slot:label>
                    <div class="subheading">Furniture</div>
                  </template>
                </v-checkbox>
                </v-col>
                <v-col sm="2">
                <v-checkbox
                  data-testid="rent-property-office-checkbox"
                  class="rent-property-office-checkbox"
                  v-model="propertyTypes"
                  value="Office"
                >
                  <template v-slot:label>
                    <div class="subheading">Office</div>
                  </template>
                </v-checkbox>
                </v-col>
                <v-col sm="2">
                <v-checkbox
                  data-testid="rent-property-commercial-checkbox"
                  class="rent-property-commercial-checkbox"
                  v-model="propertyTypes"
                  value="Commercial"
                >
                  <template v-slot:label>
                    <div class="subheading">Commercial</div>
                  </template>
                </v-checkbox>
                </v-col>
                <v-col sm="2">
                <v-checkbox
                  data-testid="rent-property-other-checkbox"
                  class="rent-property-other-checkbox"
                  v-model="propertyTypes"
                  value="Other"
                  @change="showOtherProperty = !showOtherProperty"
                >
                  <template v-slot:label>
                    <div class="subheading">Other</div>
                  </template>
                </v-checkbox>
                </v-col>
              </v-row>
              <v-layout v-if="showOtherProperty">
                <app-input
                  data-testid="rent-other-property-description-input"
                  class="rent-other-property-description-input"
                  v-model="otherProperty"
                  label="Other Property to be Stored"
                  :rules="'required'"
                  filled
                ></app-input>
              </v-layout>
            </v-layout>
          </v-card>
        </v-layout>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </stepper-layout>
</template>

<script>
import { EventBus } from "@/Event";
import StepperLayout from "@/layouts/StepperLayout";
import { dateMethodMixins } from "@/mixins/dateMethodMixins";

export default {
  components: { StepperLayout },
  props: {
    updateNeeded: {
      type: Boolean,
      default: false
    }
  },

  mixins: [dateMethodMixins],

  data() {
    return {
      showOtherProperty: false,
      storedProperty: [],
      panel: 0
    };
  },

  computed: {
    lease() {
      return this.$store.state.tenant.lease;
    },

    ecName: {
      get() {
        return this.lease.emergency_contact_name;
      },
      set(newVal) {
        this.$store.commit("updateECName", newVal);
      }
    },

    ecPhone: {
      get() {
        return this.lease.emergency_contact_phone;
      },
      set(newVal) {
        this.$store.commit("updateECPhone", newVal);
      }
    },

    ecEmail: {
      get() {
        return this.lease.emergency_contact_email;
      },
      set(newVal) {
        this.$store.commit("updateECEmail", newVal);
      }
    },

    mcName: {
      get() {
        return this.lease.military_contact;
      },
      set(newVal) {
        this.$store.commit("updateMCName", newVal);
      }
    },

    mcPhone: {
      get() {
        return this.lease.military_contact_phone;
      },
      set(newVal) {
        this.$store.commit("updateMCPhone", newVal);
      }
    },

    lienHolders: {
      get() {
        return this.lease.lien_holders;
      },
      set(newVal) {
        this.$store.commit("updateLienHolders", newVal);
      }
    },

    propertyTypes: {
      get() {
        return this.lease.personal_property_types;
      },
      set(newVal) {
        this.$store.commit("updatePropertyTypes", newVal);
      }
    },

    otherProperty: {
      get() {
        return this.lease.personal_property_other;
      },
      set(newVal) {
        this.$store.commit("updatePropertyOther", newVal);
      }
    }
  },
  created() {
    EventBus.$on("resetPanel", () => {
      this.panel = 0;
    });
  }
};
</script>
